import { orderConfirmationAccountSignUpMessageStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationAccountSignUpMessage";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";
import getColor from "@insite/mobius/utilities/getColor";

Object.assign(orderConfirmationAccountSignUpMessageStyles, {
    container: {
        css: css`
            border: 1px solid ${getColor("common.border")};
            display: flex;
            justify-content: space-between;
            width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-wrap: wrap;
                        justify-content: center;
                    `,
                    css`
                        flex-wrap: wrap;
                        justify-content: center;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    createAccountText: {
        css: css`
            // margin-right: 1rem;
            padding: 8px 1px;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 1rem;
                    `,
                    css`
                        margin-bottom: 1rem;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    createAccountButton: {
        css: css`
            // margin-left: auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            flex: 0 0 auto;
                        `,
                    ],
                    "min",
                )}
        `,
    },
});
